// Copyright (c) 2020 Deere & Company

import actions from '../actions-list';

const defaultValue = {};

const resetUnit = () => defaultValue;

const setUnit = ( state, action ) => action.unit;

export default ( state = defaultValue, action ) => {

    const actionTypes = {
        [actions.SET_UNIT]: setUnit,
        [actions.RESET_UNIT]: resetUnit
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer( state, action ) :
        state;

};
